import React, { Component } from 'react';

export default class Community extends Component {
    constructor(props) {
        super(props);
        this.state = {
            values: {
                name: '',
                email: ''
            },
            isSubmitting: false,
            isError: false,
            showSuccessModal: false,
            message: ""
        };
    }

    submitForm = async (e) => {
        e.preventDefault();
        this.setState({ isSubmitting: true });

        const res = await fetch('http://localhost:3030/api/auth', {
            method: 'POST',
            body: JSON.stringify(this.state.values),
            headers: {
                'content-type': 'application/json'
            }
        });

        this.setState({ isSubmitting: false });

        const data = await res.json();
        if (!data.hasOwnProperty('error')) {
            this.setState({ message: data.success, showSuccessModal: true });
        } else {
            this.setState({ message: data.error, isError: true });
        }

        setTimeout(() => {
            this.setState({
                isError: false,
                message: '',
                values: { name: '', email: '' },
                // showSuccessModal: false
            });
        }, 3000);
    };

    handleInputChange = (e) =>
        this.setState({
            values: { ...this.state.values, [e.target.name]: e.target.value }
        });

    render() {
        return (
            <section id="cta" className="cta">
                <div className="container" data-aos="zoom-in">
                    <div className="row text-center">
                        <h3>Join the community for the latest updates!</h3>
                        <p>Stay up to date with the news and update release</p>
                        <div className="cta-btn-container justify-content-center">
                            <a
                                className="cta-btn btn"
                                href="/"
                                onClick={(e) => {
                                    e.preventDefault();
                                    // Show the JoinCommunity modal
                                    this.setState({ showSuccessModal: false, isError: false });
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#JoinCommunity"
                            >
                                Join the Community
                            </a>
                        </div>
                    </div>
                </div>
                <div
                    className={`modal ${this.state.showSuccessModal || this.state.isError ? 'show' : ''}`}
                    id="JoinCommunity"
                    tabIndex="-1"
                    style={{ width: 'maxContent', fontFamily: 'Monda' }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg m-auto">
                        <div className="modal-content">
                            <div className="modal-body text-center" style={{ width: 'maxContent' }}>
                                {this.state.showSuccessModal ? (
                                    <>
                                        <h2 className='p-5'>Thanks for registering with us!</h2>
                                        {/* Add any additional content for success */}
                                    </>
                                ) : (
                                    <>
                                        <h2>Join the community for the latest updates!</h2>
                                        <h4>Stay up to date with the news and update release</h4>
                                        <form onSubmit={this.submitForm}>
                                            <div className="mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    name="name"
                                                    placeholder="Enter Your Name"
                                                    value={this.state.values.name}
                                                    required
                                                    onChange={this.handleInputChange}
                                                    style={{ backgroundColor: '#529BA0', color: '#fff' }}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="email"
                                                    name="email"
                                                    placeholder="Enter Your Email"
                                                    value={this.state.values.email}
                                                    required
                                                    onChange={this.handleInputChange}
                                                    style={{ backgroundColor: '#529BA0', color: '#fff' }}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <button type="submit" className="btn btn-primary">
                                                    Join the Community
                                                </button>
                                            </div>
                                        </form>
                                        {this.state.isError && (
                                            <div className="message error">
                                                {this.state.isSubmitting ? 'Submitting...' : this.state.message}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>




            </section>
        );
    }
}
